import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import "./App.css";
import { Link } from 'react-router-dom';
import React from "react";
 
const BannerSlider = () => {
    const images = [
        {
            id: 1,
            src: "/tm/react/toolways/assets/images/banner/banner-1.jpg",
            alt: "Image 1",
            title: "aca",
        },
        {
            id: 2,
            src: "/tm/react/toolways/assets/images/banner/banner-2.jpg",
            alt: "Image 2 ",
            title: "bjbjbjb hjgj",
        },
        {
            id: 3,
            src: "/tm/react/toolways/assets/images/banner/banner-3.jpg",
            alt: "Image 3",
            title: "ghrttuyt f ur",
        },
    ];
    const settings = {
        infinite: true,
        dots: false,
        arrows:true,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: true,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
                dots: false
            }
          }
        ]
    };
    return (
      <>
        <div className="imgslider">
          <Slider {...settings}>
            {images.map((item) => (
              <div key={item.id}>
                <div className="banner_slider">
                  <div className="slide-item">
                    <img src={item.src} alt={item.alt} title={item.title} />
                    <div className="banner">
                      <div className="">
                        <div className="container-fluid">
                          <div className="banner_content">
                            <h1 className="title">Power Tools & Accesories</h1>
                            <p className="text">
                              {" "}
                              Sale Up To
                              <br />
                              <strong>80%</strong>
                              Off
                            </p>
                            <Link to="#" className="thm-btn btn-rounded thm-bg-color-one">Shop Now{" "}<i className="fal fa-long-arrow-right"></i></Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </>
    );
};
export default BannerSlider;